import Swiper from "swiper";
import { Navigation } from "swiper/modules";

document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector(".swiper.testimonials-slider")) return;

  const testimonialsSwiper = new Swiper(".swiper.testimonials-slider", {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 32,
    loop: true,
    navigation: {
      enabled: true,
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        navigation: {
          enabled: false,
        },
      },
    },
  });

  const prevButton = document.querySelector(
    ".carousel-arrow.carousel-arrow-previous"
  );
  const nextButton = document.querySelector(
    ".carousel-arrow.carousel-arrow-next"
  );
  if (prevButton && nextButton) {
    prevButton.addEventListener("click", () => testimonialsSwiper.slidePrev());
    nextButton.addEventListener("click", () => testimonialsSwiper.slideNext());
  }
});
